import { ApiService } from "../../index";

export const updateLittleGroupUser = (
  group_id: string,
  append: string[],
  remove: string[]
) => {
  console.log("修改小组用户 ---- 执行函数 ---- updateLittleGroupUser");
  return ApiService.baseAction(
    `/little-group/${group_id}/update_member`,
    {
      data: {
        append: append,
        remove: remove,
      },
    },
    "post"
  );
};
